import React, { useState } from 'react';
import { ModalWrapper } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { MailSendForm, EMailSendForm } from 'components/atoms';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';

export interface MailSendModalProps extends PopupProps {
    id: number;
    group: string;
    mail_type: string; 
    mail_id?: number;   
    use_memo?: boolean;
}

const B2cMailSendModal = ({ isOpen, onClose, id, group, mail_type, mail_id = 0, use_memo = false }: MailSendModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    

  /* ======================================================
  * hooks
  * ====================================================== */

   /* ======================================================
   * variables
   * ====================================================== */

   /* ======================================================
   * events
   * ====================================================== */
    const onCancel = () => {
        onClose?.(false);
    };
        
    const onConfirm = () => {
        onClose?.(true);
    };
    
    /* ======================================================
    * methods
    * ====================================================== */
 
  /* ======================================================
   * effects
   * ====================================================== */

    return (
        <ModalWrapper open={isOpen} onCancel={onCancel} width={1280} title={'메일 발송'} closable>
            <Tabs style={{width:"100%"}} size={"small"} type="card" tabBarStyle={{marginBottom:"0px"}}>
            <Tabs.TabPane tab="신규템플릿" key="new" style={{padding:"0px"}}>
                <EMailSendForm use_memo={use_memo} id={id} mail_group={group} mail_type={mail_type} onCancel={onCancel} onConfirm={onConfirm} mail_id={mail_id}/>
            </Tabs.TabPane>
            <Tabs.TabPane tab="이전템플릿" key="old" style={{padding:"0px"}}>
                <MailSendForm id={id} mail_group={group} mail_type={mail_type} onCancel={onCancel} onConfirm={onConfirm}/>
            </Tabs.TabPane>
            </Tabs>                
        </ModalWrapper>  
    )    
};

export default React.memo(B2cMailSendModal);    